import React, { useState, useEffect } from "react";
import { useStoreLocalization } from "@src/hooks/useStoreLocalization";
import { useCurrencyForm } from "@src/hooks/useCurrencyForm";
import helpers from "@src/../js/helpers";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";
import {LoadingSpinner} from "@arctheme-components/elements/LoadingSpinner/LoadingSpinner"; // Import your spinner component

export function CurrencySelector({ settings }) {
  const { should_show_sidebar } = settings.settings;
  const { isLoading, error, success, enabledCurrencies, fetchCountries } = useStoreLocalization();
  const { submitCurrencyForm } = useCurrencyForm();
  const currencyCountry = helpers.getCookie("localization");

  const [selectedCurrency, setSelectedCurrency] = useState(currencyCountry);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add loading state

  // Access the current menu state from the global store
  const { currentMenu } = useHeaderMenuStore();

  if (!should_show_sidebar){
    return <div></div>
  }

  const handleCurrencyChange = async (isoCode) => {
    setIsSubmitting(true); // Set loading state to true
    window.dispatchEvent(new CustomEvent('show-spinner', {
      detail: {
        id: 'currency-loader',
      },
    }));

    try {
      setSelectedCurrency(isoCode);
      await submitCurrencyForm(isoCode); // Wait for form submission
    } finally {
      setIsSubmitting(false); // Reset loading state
      window.dispatchEvent(new CustomEvent('hide-spinner', {
        detail: {
          id: 'spinner-search',
        },
      }));
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  // Make setting
  const layout = "sidebar";

  return layout === "dropdown" ? (
      <div></div>
  ) : (
      <div
          className={`currency-selector flex bg-white lg:w-[441px] w-full h-full ${
              currentMenu === "CURRENCY" ? "" : "hidden"
          }`}
      >
        <div className="currency-selector__wrapper">
          {isSubmitting && (
              <div className="currency-selector__loading flex justify-center my-4">
                <LoadingSpinner id={'currency-loader'} classes={`bg-black`}/> {/* Show loading spinner while submitting */}
              </div>
          )}
          <form
              className="currency-selector__form h5"
              id="currency-form"
              action="/localization"
              method="post"
          >
            {(() => {
            const renderedNames = new Set();

            return enabledCurrencies.map((currency, index)  => {
                if (renderedNames.has(currency.name)) {
                  return null;
                }

                renderedNames.add(currency.name);

                return (
                  <label
                      key={index}
                      className={`currency-selector__form-label ${
                          selectedCurrency === currency.code ? "selected" : ""
                      }`}
                  >
                    <input type="hidden" name="form_type" value="localization" />
                    <input type="hidden" name="utf8" value="✓" />
                    <input type="hidden" name="_method" value="put" />
                    <input type="hidden" name="return_to" value="/" />
                    <input
                        type="radio"
                        name="country_code"
                        value={currency.code}
                        defaultChecked={selectedCurrency === currency.code}
                        onClick={() => handleCurrencyChange(currency.code)}
                        className="currency-selector__form-input"
                    />
                    {currency.name}
                  </label>
                );
              });
            })()}
          </form>
        </div>
      </div>
  );
}

export default CurrencySelector;
